// extracted by mini-css-extract-plugin
export var csatScore = "_he-5";
export var header = "_he-1";
export var panelWrapper = "_he-2";
export var postPreview = "_he-3";
export var rightContent = "_he-0";
export var wrappingText = "_he-4";